<template>
	<div class="table-header" :class="getClass" @click="handleSortChange">
		<div id="table-header-label" ref="table-header-label" class="table-header-label" :title="label">
			{{ label }}
		</div>

		<div v-if="sortable" class="table-header-caret">
			<div class="custom-caret-wrapper">
				<i class="el-icon-caret-top custom-caret custom-ascending" />
				<i class="el-icon-caret-bottom custom-caret custom-descending" />
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';

const ORDER = Object.freeze({
	ASCENDING: 'ascending',
	DESCENDING: 'descending',
	NONE: null,
});

export default Vue.extend({
	name: 'DmsTableHeader',
	props: {
		column: { type: Object, required: true },
		sortable: { type: Boolean, default: false },
		currentSortInfo: { type: Object, required: true },
		name: { type: String },
		label: { type: String },
	},
	data() {
		return {
			order: ORDER.NONE,
		};
	},
	computed: {
		getClass() {
			return {
				sortable: this.sortable,
				ascending: this.order === ORDER.ASCENDING,
				descending: this.order === ORDER.DESCENDING,
			};
		},
		isCurrentColum() {
			return this.currentSortInfo.columnId === this.column.columnId;
		},
	},
	watch: {
		currentSortInfo: {
			immediate: true,
			deep: true,
			handler() {
				if (this.currentSortInfo && this.isCurrentColum) this.order = this.currentSortInfo.order;
				if (this.order && !this.isCurrentColum) this.order = ORDER.NONE;
			},
		},
	},
	methods: {
		handleSortChange() {
			switch (this.order) {
				case ORDER.ASCENDING:
					this.order = ORDER.DESCENDING;
					break;
				case ORDER.DESCENDING:
					this.order = ORDER.NONE;
					break;
				default: // ORDER.NONE
					this.order = ORDER.ASCENDING;
					break;
			}
			this.$emit('sort-change', { columnId: this.order ? this.column.columnId : null, order: this.order, name: this.name });
		},
	},
});
</script>

<style lang="scss" scoped>
	@import "node_modules/element-ui/packages/theme-chalk/src/common/var";

	.table-header {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		&.sortable {
			cursor: pointer;
		}
		&-label {
			height: 34px;
			align-self: center;
			line-height: 34px;

			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
		&-caret {
			display: block;
			align-self: center;
		}
	}
	.custom-caret {
		font-size: 19px;
		border-bottom-color: transparent;
		color: $--color-text-placeholder;

		&-wrapper {
			max-width: 19px;
			height: 34px;

			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-end;
		}
	}
	.el-icon-caret {
		&-top {
			margin-bottom: -5px;
		}
		&-bottom {
			margin-top: -5px;
		}
	}
	.ascending .custom-caret.custom-ascending {
		color: $color-base-primary;
	}
	.descending .custom-caret.custom-descending {
		color: $color-base-primary;
	}
</style>
